import { Alert } from './index';

/**
 * Shared Nigeria-specific buyer due-diligence content, used by
 * PropertyDetailsPage's "Buyer Protection Tips" modal and the Messages
 * page's inline checklist banner. Keeping this in one place means the two
 * surfaces can never drift out of sync.
 */
function DueDiligenceChecklist() {
  return (
    <div className="buyer-protection-content">
      <Alert type="warning">
        <strong>Important:</strong> The platform is not liable for property accuracy, ownership,
        or tenant disputes. You are responsible for verifying all details.
      </Alert>

      <h3>Before you commit, verify:</h3>
      <ul className="buyer-checklist">
        <li>
          ✓ <strong>Property ownership</strong> - Request proof of ownership or title deed.
          Confirm at the state Land Registry
        </li>
        <li>
          ✓ <strong>Visit in person</strong> - See the property yourself; don't rely on photos
          alone
        </li>
        <li>
          ✓ <strong>Inspect thoroughly</strong> - Check walls, plumbing, electricity, and
          appliances
        </li>
        <li>
          ✓ <strong>Verify landlord identity</strong> - Check ID and confirm they are authorized
          to lease
        </li>
        <li>
          ✓ <strong>Governor's Consent</strong> - Ensure the property has Governor's Consent if
          applicable
        </li>
        <li>
          ✓ <strong>C of O / R of O</strong> - Check Certificate or Right of Occupancy validity
        </li>
        <li>
          ✓ <strong>Survey plan</strong> - Verify the survey plan matches the actual land
        </li>
        <li>
          ✓ <strong>Family land &amp; Omo-Onile risks</strong> - Investigate if the land has
          family or communal ownership claims, and be aware of land grabber activities in the
          area
        </li>
        <li>
          ✓ <strong>Ask for references</strong> - Contact previous tenants about their
          experience
        </li>
        <li>
          ✓ <strong>Understand the agreement</strong> - Read all terms carefully before signing
        </li>
        <li>
          ✓ <strong>Seek legal advice</strong> - Have a lawyer review the lease agreement
        </li>
        <li>
          ✓ <strong>Check neighborhood</strong> - Visit at different times of day
        </li>
        <li>
          ✓ <strong>Verify utility status</strong> - Confirm water, electricity, and internet
          availability
        </li>
        <li>
          ✓ <strong>Ask about complaints</strong> - Check with neighbors about any issues
        </li>
      </ul>

      <h3>Red flags to watch for:</h3>
      <ul className="buyer-warnings">
        <li>⚠️ Pressure to pay before viewing the property</li>
        <li>⚠️ Vague or incomplete information about ownership</li>
        <li>⚠️ Unusually low rent for the area</li>
        <li>⚠️ Photos that look professionally edited or unrealistic</li>
        <li>⚠️ Landlord unwilling to meet in person</li>
        <li>⚠️ No written agreement or unclear terms</li>
        <li>⚠️ Requests for payment through informal channels</li>
        <li>⚠️ Difficulty reaching the landlord after initial contact</li>
      </ul>
    </div>
  );
}

export default DueDiligenceChecklist;
